<template>
  <div class="order-details" :class="tab.id === 'details' ? 'no-footer' : ''">
    <div class="column">
      <div class="columns">
         <div class="column grouped-buttons">
                <div v-if="!editMode" class="is-flex is-justify-content-flex-end">
                  <button
                    class="button px-0 has-text-dark"
                    @click="openActivityLog"
                  >
                    <i class="icon-activityhistory"></i>
                  </button>
                  <div class="is-divider-vertical mt-0" v-if="!hasPermission"></div>
                  <button class="button px-0 has-text-dark" @click="editMode = true" v-if="!hasPermission">
                    <i class="icon-edit"></i>
                  </button>
                </div>
                <div class="is-flex is-justify-content-flex-end" v-else>
                  <button class="mr-2 button has-text-weight-bold has-background-white is-outlined is-size-4 p-0"
                    @click="cancelEdit">
                    <i class="icon-close has-text-black-bis"></i>
                  </button>
                  <button class="button has-text-weight-bold has-background-black-bis has-text-white is-size-4 p-0"
                    @click="saveProject">
                    <i class="icon-checkmark has-text-white"></i>
                  </button>
                </div>
              </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class=" project-details-col has-background-white is-border-radius-sm">
            <div class="columns">
              <div class="column pt-5 is-6">
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                  Project Name
                </h3>
                <input class="input generic-input" v-model.trim="project.name" v-if="editMode" />
                <div class="line-height generic-input is-size-3 field" v-else>
                  {{ project.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" :key="reRender">
        <div class="column">
          <div class="project-details-col has-background-white is-border-radius-sm">
            <div class="columns is-multiline">
              <div class="column is-full">
                <mf-multi-select titleLabel="Status" labelClass="has-text-black-bis is-italic is-size-3"
                  :modelValue="project.status" :multiple="false" :options="statusOptions" :allow-empty="false"
                  :closeOnSelect="true" @update:modelValue="confirmStatusChange" v-if="editMode">
                </mf-multi-select>
                <div v-else>
                  <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                    Status
                  </h3>
                  <div class="line-height generic-input is-size-3 field">
                    {{ project.status }}
                  </div>
                </div>
              </div>
              <div class="column is-full">
                <mf-multi-select titleLabel="Owner Email" labelClass="has-text-black-bis is-italic is-size-3"
                  v-model="project.projectOwner.email" placeholder="Owner Name" :preselect-first="true"
                  :options="usersEmail" :searchable="true" :allow-empty="false" @update:modelValue="changeOwner"
                  v-if="editMode">
                </mf-multi-select>
                <div v-else>
                  <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                    Owner Email
                  </h3>
                  <div class="line-height generic-input is-size-3 field">
                    {{ project.projectOwner.email }}
                  </div>
                </div>
              </div>
              <div class="column is-full">
                <h4 class="is-italic is-size-3 is-italic has-text-weight-semibold">
                  Location Details
                </h4>
                <div class="columns">
                  <div class="column">
                    <div class="columns">
                      <div class="column">
                        <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                          Name
                        </h3>
                        <input class="input generic-input" v-model.trim="project.location.name"
                          placeholder="Location Name" v-if="editMode" />
                        <div class="line-height generic-input is-size-3 field" v-else>
                          {{ project.location.name }}
                        </div>
                      </div>
                    </div>
                    <div class="columns is-multiline">
                      <div class="column">
                        <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                          Street
                        </h3>
                        <input class="input generic-input" v-model.trim="project.location.street" placeholder="Street"
                          v-if="editMode" />
                        <div class="line-height generic-input is-size-3 field" v-else>
                          <span>{{ project.location.street }}</span>
                        </div>
                      </div>
                      <div class="column">
                        <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                          City
                        </h3>
                        <input class="input generic-input" v-model.trim="project.location.city" placeholder="City"
                          v-if="editMode" />
                        <div class="line-height generic-input is-size-3 field" v-else>
                          {{ project.location.city }}
                        </div>
                      </div>
                    </div>
                    <div class="columns is-multiline">
                      <div class="column">
                        <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                          State
                        </h3>
                        <input class="input generic-input" v-model.trim="project.location.state" placeholder="State"
                          v-if="editMode" />
                        <div class="line-height generic-input is-size-3 field" v-else>
                          {{ project.location.state }}
                        </div>
                      </div>
                      <div class="column">
                        <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                          Zipcode
                        </h3>
                        <input class="input generic-input" v-model.trim="project.location.zipcode" placeholder="Zipcode"
                          v-if="editMode" />
                        <div class="line-height generic-input is-size-3 field" v-else>
                          {{ project.location.zipcode }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="project-details-col has-background-white is-border-radius-sm">
            <div class="columns is-multiline">
              <div class="column is-full">
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold mb-2">
                  Project ID
                </h3>
                <input class="input" v-model.trim="currentCompanyProjSetting.customId" placeholder="Project Id"
                  v-if="editMode" />
                <div class="line-height generic-input is-size-3 field" v-else>
                  <span>{{ currentCompanyProjSetting.customId }}</span>
                </div>
              </div>
              <div class="column is-full">
                <mf-multi-select titleLabel="Default Production Order Tab"
                  labelClass="has-text-black-bis is-italic is-size-3" v-model="editSettingTab"
                  placeholder="Select Option" :preselect-first="true" :options="editSettingTabs" :searchable="true"
                  :allow-empty="false" class="pendo-pm-default-tab-select" label="name" track-by="value"
                  @update:modelValue="updateEditTabSetting" :disabled="!editMode">
                </mf-multi-select>
              </div>
              <div class="column is-full">
                <mf-multi-select titleLabel="Project Inventory-Default Receiver"
                  labelClass="has-text-black-bis is-italic is-size-3"
                  v-model="currentCompanyProjSetting.defaultReceiver" placeholder="Select Option"
                  :preselect-first="true" :options="defaultReceiverList" :searchable="true" :allow-empty="false"
                  class="pendo-pm-default-tab-select" label="name" track-by="_id" :disabled="!editMode">
                </mf-multi-select>
              </div>
              <div class="column is-full">
                <mf-multi-select titleLabel="Project Inventory Location"
                  labelClass="has-text-black-bis is-italic is-size-3"
                  v-model="currentCompanyProjSetting.projectInventoryLocation" placeholder="Select Option"
                  :preselect-first="true" :options="inventoryLocationList" :searchable="true" :allow-empty="false"
                  group-values="val" group-label="key" label="name" :disabled="!editMode || isLocationDisabled">
                </mf-multi-select>
                <div class="field">
                  <p class="line-height has-text-dark is-size-3">
                    (<span class="has-text-weight-bold">NOTE</span>: Project
                    Inventory Location cannot be edited once any production order
                    has moved to the manufacturing stage)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="project-details-col has-background-white is-border-radius-sm">
            <div class="columns is-multiline">
              <div class="column is-full">
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold  mb-2">
                  Thumbnail
                </h3>
                <div v-if="getPresignedUrl" class="is-flex is-flex-direction-column">
                  <div class="">
                    <button v-if="editMode" class="button has-background-black-bis is-medium has-text-white my-2"
                      @click="removeThumbnail">
                      Delete
                    </button>
                  </div>
                  <div class="details-empty-box">
                    <img  :src="getPresignedUrl" />
                  </div>
                </div>
                <div v-else-if="editMode">
                  <mf-file-picker accept="image/png, image/jpeg" path="projects/addAvatar" filePath="imageUrl"
                    :multiple="false" :isImageUpload="true" :hideLimitText="true" :param="{ projectId: project._id }"
                    @onInput="(file) => updateThumbnail(file)">Add Image</mf-file-picker>
                  <div class="details-empty-box" :src="getPresignedUrl"></div>
                </div>
              </div>
              <div class="column is-full" v-if="!editMode">
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                  Order Onsite-Date Reminder
                </h3>
                <p class="subtitle is-spaced">{{ currentCompanyProjSetting.notifications }} Day(s) before</p>
              </div>
              <div v-else class="column is-full">
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                  Order Onsite-Date Reminder (Range 1-7)
                </h3>
                <div class="columns">
                  <div class="column is-narrow">
                    <o-switch class="is-size-3 has-text-black-bis has-text-weight-bold"
                      v-model="currentCompanyProjSetting.toNotify" @click="remainderValidation">
                    </o-switch>
                  </div>
                  <div class="column is-2 pl-0 is-narrow">
                    <input type="number" class="input" step="any"
                      v-model.number="currentCompanyProjSetting.notifications"
                      :disabled="!currentCompanyProjSetting.toNotify" :min="1" :max="7" @input="remainderValidation"
                      @blur="updateVal">
                  </div>
                  <div class="column">
                    <span class="has-text-dark is-size-3 line-height">Day(s) before</span>
                  </div>
                </div>
              </div>
              <div class="column is-full" v-if="!editMode">
                <label class="has-text-black-bis is-italic is-size-3 line-height">
                  Project Purchase Order Numbers
                </label>
                <div class="columns">
                  <div class="column  is-size-3 line-height">
                    <span>Generation is </span>
                    <span v-if="project.generatePon">Enabled</span>
                    <span v-else>Disabled</span>
                  </div>
                </div>
                <label class="has-text-black-bis is-italic is-size-3 line-height">
                  Purchase Order Number
                </label>
                <div class="columns">
                  <div class="column is-4">
                    <span class="has-text-black-bis is-size-3 line-height">Prefix: </span>
                    <span class="is-6" v-if="!$_.isEmpty($_.get(project, 'purchaseOrderNumber.prefix', ''))">
                      {{ project.purchaseOrderNumber.prefix }}
                    </span>
                    <span v-else class="has-text-black-bis is-size-3 line-height"> <b> N/A</b></span>
                  </div>
                  <div class="column is-3">
                    <span class="has-text-black-bis is-size-3 line-height">Start At: </span>
                    <span class="is-6" v-if="!$_.isEmpty($_.get(project, 'purchaseOrderNumber.prefix', ''))">
                      {{ $_.get(project, 'purchaseOrderNumber.start', '') }}
                    </span>
                    <span v-else class="has-text-black-bis is-size-3 line-height"> <b> N/A</b></span>
                  </div>
                  <div class="column is-5">
                    <span class="has-text-black-bis is-size-3 line-height">Next Number: </span>
                    <span v-if="!$_.isEmpty($_.get(project, 'purchaseOrderNumber.prefix', ''))" class="is-6">
                      {{ $_.get(project, 'purchaseOrderNumber.prefix', '') }}{{ $_.get(project,
                        'purchaseOrderNumber.nextNumber', '') }}
                    </span>
                    <span v-else class="has-text-black-bis is-size-3 line-height"> <b> N/A</b></span>
                  </div>
                </div>
              </div>
              <div v-else class="column is-full">
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                  Project Purchase Order Numbers
                </h3>
                <div class="columns">
                  <div class="column">
                    <o-checkbox v-model="project.generatePon"
                      class="is-size-3 has-text-black-bis is-justify-content-flex-start">
                      Generate
                    </o-checkbox>
                  </div>
                </div>
                <h3 class="has-text-black-bis is-italic is-size-3 line-height has-text-weight-semibold">
                  Purchase Order Number
                </h3>
                <div class="columns">
                  <div class="column is-5">
                    <div class="columns is-align-items-center">
                      <div class="column is-narrow">
                        <span class="title is-6 is-pulled-left">Prefix </span>
                      </div>
                      <div class="column">
                        <span class="is-pulled-left"> <o-input placeholder="(18 characters max)" class="is-spaced input"
                            maxlength="18" v-model.trim="project.purchaseOrderNumber.prefix"
                            @input="(e) => project.purchaseOrderNumber.prefix = updateParams(e.target.value)"></o-input>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="column is-3">
                    <div class="columns  is-align-items-center">
                      <div class="column  is-narrow">
                        <span class="title is-6">Start At</span>
                      </div>
                      <div class="column">
                        <input type="number" style="width:100%" placeholder="start" class="is-spaced"
                          v-model.trim="project.purchaseOrderNumber.start" min="6" max="6"
                          @input="(e) => project.purchaseOrderNumber.start = update(e.target.value)">
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="columns  is-align-items-center">
                      <div class="column is-narrow">
                        <span class="title is-6">Next Number </span>
                      </div>
                      <div class="column">
                        <span v-if="!$_.isEmpty($_.get(project, 'purchaseOrderNumber.prefix', ''))" class="is-6">
                          {{ $_.get(project, 'purchaseOrderNumber.prefix', '') }}
                          {{ $_.get(project, 'purchaseOrderNumber.nextNumber', '') }}
                        </span>
                        <span v-else class="title is-6"> <b>N/A</b></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <o-loading :active="isLoading" :full-page="false" />
  </div>
  <activity-log
      :id="activityDetail.id"
      :projectId="activityDetail.projectId"
      :isActive="isActivityLogOpen"
      :orderName="activityDetail.orderName"
      @update:isActive="isActivityLogOpen = false"
      :type = "module"
    ></activity-log>
</template>

<script>
import { DialogProgrammatic } from '@/components/Dialog';
import _ from "lodash";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { toRefs, reactive, computed, onBeforeMount, onMounted } from "vue";
import Projects from "@/models/Projects";
import Locations from "@/models/Locations";
import MfFilePicker from '@/components/MfFilePicker.vue';
import s3FileAccess from '@/models/SimpleStorageService'
import ActivityLog from '@/components/ActivityLog.vue';
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default {
  name: "Shipping Details",
  components: {
    'mf-file-picker': MfFilePicker,
    ActivityLog,
  },
  props: {
    tab: Object,
    rowData: Object,
  },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();

    const { getPermissionValues } = PermissionMixin();

    const statusOptions = ['Active', 'Archived'];
    const editSettingTabs = [
      { name: 'Work Steps', value: 'runs' },
      { name: 'Items', value: 'items' },
      { name: 'Tasks', value: 'Checklist' },
      { name: 'Materials', value: 'materials' },
    ]

    const data = reactive({
      project: {},
      tabName: "",
      userData: {},
      editMode: false,
      usersEmail: [],
      companyData: {},
      projectClone: {},
      isLoading: false,
      presignedUrl: '',
      editSettingTab: {},
      allLocationList: [],
      defaultReceiverList: [],
      inventoryLocationList: [],
      currentCompanyProjSetting: {},
      activityDetail: {
        id: '',
        projectId: '',
        orderName: '',
      },
      isActivityLogOpen: false,
      hasPermission: true,
      isLocationDisabled: false,
    });

    onBeforeMount(async () => {
      try {
        data.isLoading = true;
        data.project = _.cloneDeep(props.rowData)
        data.hasPermission = getPermissionValues({
          permissionModule: 'app&projects',
          type: 'alterProject',
        })
        data.userData = store.state.userData;
        if (!_.isEmpty(data.project.projectSettings)
          && (data.project.projectSettings.length !== 0)) {
          data.currentCompanyProjSetting = _.cloneDeep(_.find(data.project.projectSettings, (setting) => setting.companyId === (data.userData.company._id || data.userData.company)));
        }

        data.editSettingTab = _.find(editSettingTabs, { value: data.currentCompanyProjSetting.editSettingTab }) || { name: 'Work Steps', value: 'runs' }
        data.companyData = store.state.companyData
        if (_.isEmpty(data.companyData)) {
          await store.dispatch('getCompanyData')
          data.companyData = store.state.companyData;
        }
        data.allCompanyUsers = await Projects.allMyCompanyUsers();
        data.usersEmail = _.map(data.allCompanyUsers, 'email');

        const locations = [];
        const projectList = [];
        const [GI] = await Projects.allProjects({ isGI: true });
        if (GI) projectList.push(GI._id);
        if (!_.isEmpty(projectList)) {
          const locs = await Locations.allLocationForUser({
            companyId: data.currentCompanyProjSetting.companyId,
            project: projectList,
          });
          locations.push(...locs);
        } else {
          const compLocations = (await Locations.allCompanyLocations({
            companyId: data.currentCompanyProjSetting.companyId,
            type: 'company_location',
          })).data;
          locations.push(...compLocations);
        }
        data.allLocationList = locations;
        if (!_.isEmpty(locations) && !_.isEmpty(data.currentCompanyProjSetting.projectInventoryLocation)) {
          const locObj = _.find(locations, (location) => location._id === data.currentCompanyProjSetting.projectInventoryLocation._id);
          if (!_.isEmpty(locObj)) {
            data.currentCompanyProjSetting.projectInventoryLocation = locObj
          }
        }
        data.inventoryLocationList = Locations.groupLocations(
          _.uniq(locations),
          store.state.companyData,
        );
        const users = await Projects.listProjectUsers({
          project_id: data.project._id,
          limit: 1000,
          sort: 'name',
        });
        data.defaultReceiverList = users.data;
        data.projectClone = _.cloneDeep(data.project);
        await updateAvatarRender();
        data.isLocationDisabled = await Projects.isInvLocDisabled({ projectId: data.project._id });
      } catch (e) {
        console.error('Error: ', e)
      } finally {
        data.isLoading = false
      }
    });

    const confirmStatusChange = (val) => {
      let message;
      if (data.project.status !== 'Archived') {
        message = 'Are you sure you want to ARCHIVE this project for all the member companies?';
      } else {
        message = 'Are you sure you want to ACTIVATE this project?';
      }

      DialogProgrammatic.confirm({
        title: 'Change Project Status',
        message,
        okButton: 'Yes',
        cancelButton: 'Cancel',
        onConfirm: () => {
          data.project.status = val
          data.currentCompanyProjSetting.status = val
        },
      })
    }

    const changeOwner = (selectedVal) => {
      const newOwner = _.find(
        data.allCompanyUsers,
        (companyUser) => companyUser.email === selectedVal,
      );
      data.project.projectOwner.name = newOwner.name;
      data.project.contactEmail = newOwner.email;
    }

    const updateEditTabSetting = (opt) => {
      data.currentCompanyProjSetting.editSettingTab = opt.value;
    }

    const updateThumbnail = async (file) => {
      data.project.imageUrl = file
      await updateAvatarRender()
    }

    const updateAvatarRender = async () => {
      const fileGuid = _.get(data.project, 'imageUrl.fileGuid', '');
      let type = 'project';
      const params = {
        type,
        id: fileGuid,
      }
      if (fileGuid !== '') {
        params.projectId = data.project._id
        const { presignedUrl } = await s3FileAccess.getS3File(params);
        data.presignedUrl = presignedUrl;
        return true;
      }
    }

    const getPresignedUrl = computed(() => {
      return data.presignedUrl
    })

    const removeThumbnail = () => {
      data.project.imageUrl = ''
      data.presignedUrl = ''
    }

    const remainderValidation = () => {
      if (data.currentCompanyProjSetting.notifications < 0
        || data.currentCompanyProjSetting.notifications > 7) { data.currentCompanyProjSetting.notifications = 1; }
    }

    const updateVal = () => {
      if (data.currentCompanyProjSetting.notifications < 1
        || data.currentCompanyProjSetting.notifications > 7) { data.currentCompanyProjSetting.notifications = 1; }
    }

    const updateParams = (e) => {
      e = e.toUpperCase();
      const existingPrefix = _.find(data.project.purchaseOrderHistory, { prefix: e });
      if (e === _.get(data.projectClone, 'purchaseOrderNumber.prefix', '')) {
        data.project.purchaseOrderNumber.start = data.projectClone.purchaseOrderNumber.start;
        data.project.purchaseOrderNumber.nextNumber = data.projectClone.purchaseOrderNumber.nextNumber;
      } else if (!_.isEmpty(existingPrefix)) {
        data.project.purchaseOrderNumber.start = existingPrefix.start;
        data.project.purchaseOrderNumber.nextNumber = existingPrefix.nextNumber;
      } else {
        data.project.purchaseOrderNumber.start = '000001';
        data.project.purchaseOrderNumber.nextNumber = '000001';
      }
      return e;
    };

    const update = (val) => {
      let updatedValue = val;
      updatedValue = updatedValue.toString();
      if (updatedValue.length > 6 || updatedValue.length === 0) updatedValue = '000001';
      data.project.purchaseOrderNumber.nextNumber = updatedValue;
      return updatedValue;
    }

    const projIdValidation = (projId) => {
      const regex = '^[a-zA-Z0-9-]+$'
      if (_.isEmpty(projId) || projId.trim().length < 3 || projId.trim().length > 16
        || !RegExp(regex).test(projId)) return false
      return true
    }

    const validateZip = (zipCode, showError) => {
      // US team requirement https://github.com/manufacton/Rio/issues/10237
      zipCode = !_.isEmpty(zipCode) ? zipCode : '';
      if (!_.inRange(zipCode.length, 1, 25)) {
        if (showError) {
          toast.error('Valid range for Zip length is 1 - 24!')
        }
        return false;
      }
      return true;
    }

    const validations = () => {
      if (_.isEmpty(data.project.name) || data.project.name.trim().length < 3) {
        toast.error('Please Check the inputs for project name')
        return false;
      } if (data.project.isTemplateProject !== true
        && !projIdValidation(data.project.linkedProjectSetting.customId)) {
        toast.error('Please enter valid Project ID (Project ID can only contain 3 to 16 alpha-numeric characters and dashes)');
        return false;
      } if (_.isEmpty(data.project.linkedProjectSetting.projectInventoryLocation)) {
        toast.error('Project Inventory Location is Required');
        return false;
      } if (_.isEmpty(data.project.linkedProjectSetting.defaultReceiver)) {
        toast.error('Project Inventory-Default Receiver is Required');
        return false;
      } if (data.project.isTemplateProject
        && (data.project.status === 'Archived'
          || data.project.linkedProjectSetting.status === 'Archived')) {
        toast.error('Template Project can not be Archive');
        return false;
      } if (data.project.linkedProjectSetting.toNotify
        && (!data.project.linkedProjectSetting.notifications
          || data.project.linkedProjectSetting.notifications < 1
          || data.project.linkedProjectSetting.notifications > 7)) {
        toast.error('Please set reminder in the range 1 - 7');
        return false;
      } if (_.isEmpty(data.project.location)) {
        toast.error('Please fill project location details');
        return false;
      } if (!_.isEmpty(data.project.location)) {
        if (_.trim(data.project.location.name).length < 3) {
          toast.error('Location name should be atleast 3 characters long!');
          return false;
        } if (_.trim(data.project.location.street).length < 3) {
          toast.error('Street name should be atleast 3 characters long!');
          return false;
        } if (_.trim(data.project.location.city).length < 3) {
          toast.error('City name should be atleast 3 characters long!');
          return false;
        } if (_.trim(data.project.location.state).length < 2) {
          toast.error('State name should be atleast 2 characters long!');
          return false;
        } if (!validateZip(data.project.location.zipcode, true)) {
          return false;
        }
      }
      return true;
    }

    const getProject = async () => {
      data.project = await Projects.getOne(data.project._id);
    }

    const saveProject = async () => {
      let project;
      data.project.linkedProjectSetting = _.cloneDeep(data.currentCompanyProjSetting)
      if (validations()) {
        if (!_.isEmpty(data.project.purchaseOrderNumber.prefix)) {
          let allowToSave = await Projects.getProjectWithPrefix({
            projectId: data.project._id,
            prefix: data.project.purchaseOrderNumber.prefix,
          });
          if (data.companyData.purchaseOrderNumber.prefix
            === data.project.purchaseOrderNumber.prefix
            || _.find(data.companyData.purchaseOrderHistory, {
              prefix: data.project.purchaseOrderNumber.prefix,
            })) {
            allowToSave = 1;
          }
          if (allowToSave > 0) {
            DialogProgrammatic.comfirm({
              title: 'Fix Purchase Order Prefix',
              message: 'That Purchase Order Prefix is in use - please select another',
              okButton: 'OK',
            })
            return;
          }
        }
        data.isLoading = true;
        const projectSettingsIdx = _.findIndex(
          data.project.projectSettings,
          { companyId: data.userData.company._id || data.userData.company },
        );
        _.set(data.project.projectSettings, projectSettingsIdx, data.currentCompanyProjSetting);

        try {
          project = await Projects.update(data.project);
          // if (this.forgeRefreshEvt) {
          //   this.forgeRefreshEvt = false;
          //   if (this.$refs.companyProjectSettings) {
          //     await this.$refs.companyProjectSettings.refreshUrn(false);
          //   }
          // }
          data.isLoading = false;
          toast.success('Project updated')
        } catch (errors) {
          toast.error(`Error: ${errors.data._errmsg}`)
          setTimeout(() => {
            data.isLoading = false;
          }, 3000);
        }
        await getProject();
        if (!_.isEmpty(data.project.projectSettings)
          && (data.project.projectSettings.length !== 0)) {
          data.currentCompanyProjSetting = _.cloneDeep(_.find(data.project.projectSettings, (setting) => setting.companyId === (data.userData.company._id || data.userData.company)));
        }
        if (!_.isEmpty(data.allLocationList) && !_.isEmpty(data.currentCompanyProjSetting.projectInventoryLocation)) {
          const locObj = _.find(data.allLocationList, (location) => location._id === data.currentCompanyProjSetting.projectInventoryLocation._id);
          if (!_.isEmpty(locObj)) {
            data.currentCompanyProjSetting.projectInventoryLocation = locObj
          }
        }
        // if (data.project._id === (this.queryParams.project && this.queryParams.project._id)) {
        //   this.$store.commit('setQueryParams', { project: this.project });
        // }
        data.editMode = false;
        const updateFields = ['projects', 'projectsAndGI', '_projects', '_projectsAndGI'];
        const { queryParams } = store.state;
        updateFields.forEach((key) => {
          const projectIdx = _.findIndex(queryParams[key], { _id: data.project._id });
          if (projectIdx > -1) {
            queryParams[key][projectIdx] = data.project;
            store.commit('setQueryParams', { [key]: queryParams[key] });
          }
        });
        // data.project.projectSettings.forEach((key) => {
        //   if (key.status === 'Archived') bus.$emit('initializeQp', { action: 'archive', project: this.project });
        // });
        // this.compSetting += 1;
        // this.proInfo += 1;
        // if ((this.projectId === 'new' || this.activeTab === 'CompanyProjectSettings')
        //   && this.$store.state.activeScreen === 'view-project') {
        //   this.$router.push(`/projects/${project._id}/${this.activeTab}`);
        // }
        // this.$store.state.queryParams.projectId = project._id;
      }
    }

    const cancelEdit = async () => {
      emit('refreshCardViewOnKey', true);
      data.editMode = !data.editMode
    }

    const openActivityLog = () => {
      data.isActivityLogOpen = true;
    };

    onMounted(async () => {
       data.activityDetail.id = data.project._id;
       data.activityDetail.projectId = data.project._id;
       data.activityDetail.orderName = data.project.name;
    })

    return {
      update,
      updateVal,
      cancelEdit,
      changeOwner,
      saveProject,
      updateParams,
      statusOptions,
      ...toRefs(data),
      editSettingTabs,
      updateThumbnail,
      getPresignedUrl,
      removeThumbnail,
      confirmStatusChange,
      remainderValidation,
      updateEditTabSetting,
      openActivityLog
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.o-field.has-text-centered.drag-drop) {
  text-align: start !important;
}

::v-deep(.o-upl) {
  height: auto !important;
  display: block !important;
}


</style>>